<template>
  <v-card outlined tile class="ma-3 text-center">
    <v-card outlined tile class="d-flex justify-start">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Наименование</v-chip>
      </v-card>
      <v-card outlined tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="COMP_NAME" :readonly="mode!='editor'" dense />
      </v-card>
    </v-card>
    <v-card outlined tile class="d-flex justify-start">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Код</v-chip>
      </v-card>
      <v-card outlined tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="COMP_CODE" :readonly="mode!='editor'" dense/>
      </v-card>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: 'refComponentCard',
  props: ['component', 'mode'],
  computed: {
    COMP_NAME: {
      get () {
        return this.component ? this.component.COMP_NAME : ''
      },
      set (val) {
        this.$emit('onCompUpdate', { COMP_NAME: val })
      }
    },
    COMP_CODE: {
      get: function () {
        return this.component ? this.component.COMP_CODE : ''
      },
      set (val) {
        this.$emit('onCompUpdate', { COMP_CODE: val })
      }
    }
  },
  mounted () {
    console.log('refComponentCard mounted with component ', this.component, 'and mode ', this.mode)
  }
}
</script>
